import { components } from 'be-types';
import { MultiSelectTaskItemOption, TaskItemOption } from './task.model';

export type CreateTaskItemFileRequest = components['schemas']['CreateTaskItemFileRequest'];
export type CreateReportRequest = components['schemas']['CreateReportRequest'];

export interface BaseTaskItem {
  isCompleted: boolean;
  id: number;
  itemTypeID: number;
  order: number;
  parentItemOptionID?: number;
  multiSelectOptionsParentID?: number;
  parentTaskItemID?: number;
  prompt: string;
  response?: string | number | boolean;
  taskID: number;
  taskItemID: number;
  taskToSpawn: number;
  taskItemOptions: TaskItemOption[];
  multiSelectOptions: MultiSelectTaskItemOption[];
  indexLabel: string;
  optional: boolean;
  score?: number;
  currentScore?: number;
}

export type TaskToSpawnResource = components['schemas']['TaskTaskToSpawnResource'];

export interface TaskItem extends BaseTaskItem {
  children: TaskItem[];
  id: number;
  itemOptionID: number;
  indexLabel: string;
  isCompleted: boolean;
  nameAddition?: string;
  optional: boolean;
  taskToSpawnObject?: TaskToSpawnResource;
  spawnTaskDefaultDueDate: string;
  isItemChildOfRadioOption?: boolean;
}

export interface TaskFormTaskItem extends TaskItem {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any[];
}

export interface TaskItemType {
  id: number;
  itemTypeName: string;
  itemTypeDescription: string;
}

export interface NewTaskItemPayload {
  taskID?: number;
  itemTypeID: number;
  prompt: string;
  parentTaskItemID?: number;
  parentItemOptionID?: number;
  multiSelectOptionsParentID?: number;
}

export interface DuplicateTaskItem {
  taskID: number;
  itemID: number;
}

export enum TaskItemTypeEnum {
  CheckBox = 1,
  RadioList = 2,
  TextBox = 3,
  DropdownBox = 4,
  DatePicker = 5,
  // Checklist = 6,
  Label = 7,
  Reassign = 8,
  FileAttachment = 9,
  AssignTask = 10,
  DeadlineDatePicker = 11,
  // AssignAuditTask = 12,
  AppendToTitle = 13,
  MultiSelect = 14,
  MultiSelectDropdown = 15,
}
export interface AddItemOption {
  action: string;
  itemID: number;
  prompt: string;
}
export type UpdateItemOption =
  | Pick<TaskItemOption, 'id' | 'itemID' | 'prompt'>
  | (Pick<TaskItemOption, 'id' | 'itemID' | 'score'> & { locationID?: number });
